module.exports = __webpack_public_path__ + "static/media/ca.f8c2d112.svg";